import { computed } from 'vue';
import { IRouter, Routes } from '@/models/router/router.interface';
import { INavigationItem } from '@/models/navigation.interface';
import store from '@/store';

export default class NavigationBarCode {
	public navItems = computed((): INavigationItem[] => {
		return [
			{
				label: 'Import',
				path: Routes.IMPORT_FILE
			},
			{
				label: 'Status',
				path: Routes.OVERVIEW
			}
		];
	});

	private router = computed((): IRouter => {
		return store.getters.router();
	});

	public isPathActive(path: Routes): boolean {
		return this.router.value.current === path
			|| (this.router.value.current === Routes.ERROR_DETAILS && path === Routes.OVERVIEW);
	}

	public navigateToPage(path: Routes): void {
		store.mutations.setCurrentRoute(path);
	}
}
